/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { forwardRefWithAs } from '@balance-web/utils';
import { Elevate } from '@balance-web/elevate';

import { DialogBase } from './DialogBase';

// NOTE: ideally this wouldn't be necessary. It could be resolved with a
// significant refactor, where the `ContentDialog` accepts `header/body/footer |
// children` and layout is enforced when `body` is present in props.

type BlankDialogProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

/** @deprecated The BlankDialog component has been deprecated and will be removed in future versions. Use the SideDrawer package instead.  */
export const BlankDialog = forwardRefWithAs<'div', BlankDialogProps>(
  ({ children, ...props }, ref) => {
    return (
      <DialogBase ref={ref} elevation="modal" {...props}>
        <Elevate>{children}</Elevate>
      </DialogBase>
    );
  }
);
